export const PeriodType = {
	ACTION: 'action',
	BREAK:  'break',
};
